module.exports = __webpack_public_path__ + "pcsg/img/productlist-01.8fdda748.jpg";